import protobuf from "protobufjs";
import { t } from "@/utils";
import { useAuth } from "@/store/auth";
import protoRoot from "./proto-root";

const CHANNEL = "lowBattery";
const LOW_BATTERY_LEVEL = 20;

type PushNotificationPayload = {
  channel: string;
  iosPayload: Keyable<unknown>;
  androidPayload: Keyable<unknown>;
};

const encode = ({ channel, iosPayload, androidPayload }: PushNotificationPayload) => {
  const PushNotification = protoRoot.lookupType("pushNotification.PushNotification");
  const pushNotification = PushNotification.create({
    channel,
    iosPushNotification: { payload: JSON.stringify(iosPayload) },
    androidPushNotification: { data: JSON.stringify(androidPayload) }
  });
  const buffer = PushNotification.encode(pushNotification).finish();
  return protobuf.util.base64.encode(buffer, 0, buffer.length);
};

const create = ({ batteryLevel }: { batteryLevel: number }) => {
  const { name: cameraName, xmppCredentials } = useAuth.getState().device;
  if (!xmppCredentials) return null;

  const jid = xmppCredentials.xmppLogin;
  return {
    channel: CHANNEL,
    iosPayload: {
      aps: {
        category: CHANNEL,
        alert: {
          title: t("notification.lowBattery.title", { 0: cameraName }),
          body: t("notification.lowBattery.subtitle")
        },
        sound: "default",
        "mutable-content": 1
      },
      jid,
      cameraName,
      batteryLevel
    },
    androidPayload: { type: CHANNEL, jid, cameraName, batteryLevel: String(batteryLevel) }
  };
};

const LowBatteryNotification = {
  encode,
  create,
  LOW_BATTERY_LEVEL,
  CHANNEL
};
export default LowBatteryNotification;
